module.exports = (__parcel__import__("6fgH6")).then(() => parcelRequire('4MKVl'));